import analytics from '@/plugins/analytics/analytics'

const analyticsLogger = (to) => {
  analytics.loadPage(to.name)
}

export default [analyticsLogger]
